// @flow
import React, { Component } from 'react';

import './styles.css';

class Base64FileUpload extends Component<any, any> {

  result: any[] = [];

  propagateChange = (data: any): void => {
    const { multiple } = this.props;

    if (multiple) {
      if (!this.result) {
        this.result = [];
      }

      this.result.push(data);
    } else {
      this.result = data;
    }

    this.props.onChange(this.result);
  }

  handleOnChange = (event: any): void => {
    this.result = [];

    this.readFileEvent(event.target);
  }

  readFileEvent = (inputValue: any): void => {
    const { multiple, name } = this.props;

    for (let i = 0; i < inputValue.files.length; i++) {
      let filename;
      const file: File = inputValue.files[i];
      const fr: FileReader = new FileReader();

      if (!multiple) {
        filename = file.name;
      } else {
        filename = inputValue.files.length + ' files';
      }

      fr.onloadend = (e) => {
        const result = {
          size: file.size, /* bytes */
          type: file.type,
          name: file.name,
          content: this._arrayBufferToBase64(fr.result)
        };

        this.propagateChange({
          name,
          filename,
          value: result
        });
      };

      fr.readAsArrayBuffer(file);
    }
  }

  // http://stackoverflow.com/questions/9267899/arraybuffer-to-base64-encoded-string
  _arrayBufferToBase64 = (buffer: any) => {
    let binary = '';
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;

    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }

    return window.btoa(binary);
  }

  _validate = (value) => {
    const { accept, multiple } = this.props;

    let valid = true;
    let regExp: RegExp = new RegExp('/*/');
    let exp;
    let fileExt;

    if (accept && accept !== '*') {
      exp = accept.trim().replace(/[,\s]+/gi, '|').replace(/\./g, '\\.').replace(/\/\*/g, '/.*');
      regExp = new RegExp(exp);
    }

    if (exp && accept && value) {
      if (multiple) {
        for (let i = 0; i < value.length; i++) {
          const file = value[i];
          fileExt = '.' + file.name.split('.').pop();
          valid = regExp.test(file.type) || regExp.test(fileExt);

          if (!valid) {
            break;
          }
        }
      } else {
        fileExt = '.' + value.filename.split('.').pop();
        valid = regExp.test(value.filetype) || regExp.test(fileExt);
      }
    }

    return valid;
  }

  _renderIcon = () => {
    const { icon } = this.props;
    const Icon = icon;

    return !!icon
      ? <Icon />
      : <svg viewBox="64 64 896 896" focusable="false" data-icon="cloud-upload" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M518.3 459a8 8 0 00-12.6 0l-112 141.7a7.98 7.98 0 006.3 12.9h73.9V856c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V613.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 459z"></path><path d="M811.4 366.7C765.6 245.9 648.9 160 512.2 160S258.8 245.8 213 366.6C127.3 389.1 64 467.2 64 560c0 110.5 89.5 200 199.9 200H304c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8h-40.1c-33.7 0-65.4-13.4-89-37.7-23.5-24.2-36-56.8-34.9-90.6.9-26.4 9.9-51.2 26.2-72.1 16.7-21.3 40.1-36.8 66.1-43.7l37.9-9.9 13.9-36.6c8.6-22.8 20.6-44.1 35.7-63.4a245.6 245.6 0 0152.4-49.9c41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.2c19.9 14 37.5 30.8 52.4 49.9 15.1 19.3 27.1 40.7 35.7 63.4l13.8 36.5 37.8 10C846.1 454.5 884 503.8 884 560c0 33.1-12.9 64.3-36.3 87.7a123.07 123.07 0 01-87.6 36.3H720c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h40.1C870.5 760 960 670.5 960 560c0-92.7-63.1-170.7-148.6-193.3z"></path></svg>
  }

  render() {
    const { id, name, accept, multiple, label, help, value = {}, showFileName = true } = this.props;
    const { filename } = value;

    const labelFor = id ? id : name || 'base64-file-input';

    return (
      <div className="base64-file-upload-container">
        <label className="base64-file-upload" htmlFor={labelFor}>
          <span className="file-upload-icon">
            { this._renderIcon() }
          </span>
          { label }
          { this.props.children }
        </label>

        <input type="file" className="base64-file-upload-input"
            id={ id ? id : name || 'base64-file-input' }
            name={ name ? name : 'base64-file-input' }
            accept={ accept || '*' }
            multiple={ multiple ? true : null }
            onChange={ this.handleOnChange }
            onClick={ (event)=> {
                event.target.value = null;
              }
            }
          />

        { !filename && help }

        { showFileName && <span className="base64-file-upload-filename">{ filename }</span> }

      </div>

    )
  }
}

export default Base64FileUpload;